// extracted by mini-css-extract-plugin
export default {"root":"ReferenceGuideSectionDialog_root__zXxzX"};